import IconButton from 'particles/Button/IconButton'
import styled from 'particles/themes/styled'
import React from 'react'
import { FileState } from '.'
import { buildMediaUrl } from 'services/cloudinary'

interface PreviewProps {
    media?: FileState
    onClose: () => void
}

const Preview = ({ media, onClose }: PreviewProps) => {
    if (!media) return null
    return (
        <>
            <Overlay />
            <PreviewContainer onClick={onClose}>
                <div className="modal-preview" onClick={e => e.stopPropagation()}>
                    <IconButton form="icon" color="neutral" icon="x" size="l" className="close-btn" onClick={onClose} />
                    {media?.resource_type === 'video' ? (
                        <video src={media.preview ? media.preview : buildMediaUrl(media)} controls />
                    ) : (
                        <img src={media.preview ? media.preview : buildMediaUrl(media)} />
                    )}
                </div>
            </PreviewContainer>
        </>
    )
}

export default Preview

const Overlay = styled.div`
    position: fixed;
    top: 0px;
    left: 0px;
    width: 100vw;
    height: 100vh;
    background-color: ${({ theme }) => theme.colors.surface.primaryInverse};
    opacity: 0.8;
    z-index: 999;
`

const PreviewContainer = styled.div`
    position: fixed;
    top: 0px;
    left: 0px;
    width: 100vw;
    height: 100vh;
    display: flex;
    align-items: center;
    justify-content: center;
    z-index: 1000;

    .modal-preview {
        max-width: 90%;
        width: auto;
        height: auto;
        max-height: 90%;
        background-color: ${({ theme }) => theme.colors.surface.primary};
        position: relative;
        padding: 44px;

        .close-btn {
            position: absolute;
            top: 12px;
            right: 12px;
        }

        video,
        img {
            width: 100%;
            height: 100%;
            max-width: 80vw;
            max-height: 80vh;
        }
    }
`
